import React, { useCallback, useEffect, useState } from 'react'
import KeyTitleLabel from './KeyTitleLabel';
import KeyTitleEdit from './KeyTitleEdit';
import KeyTitleDelete from './KeyTitleDelete';
import Leds from '../leds/Leds';
import Glide from '../glide/Glide';
import { useItemListenerContext } from '../../../../providers/ItemListenerContextProvider';
import { processedTitle } from '../ConfigItem';
import './KeyTitleCtrl.css';

export default function KeyTitleCtrl({folderPath, keyName, kInfo, setShowConfirm, deleteMode, tabIx = '1', ...rest}) {
  const LABEL_MODE = 'label';
  const INPUT_MODE  = 'edit';
  const DELET_MODE = 'delete';
  const [mode, setMode] = useState(deleteMode ? DELET_MODE : kInfo.titleEdit ? INPUT_MODE : LABEL_MODE);
  const [locked, setLocked] = useState(kInfo.titleLocked);
  const [success, setSuccess] = useState(kInfo.titleSuccess);

  const {tagTitleLocked, resetTitleLocked} = useItemListenerContext();

  const title = processedTitle(kInfo.title, keyName);

  const isCustom=Boolean(kInfo.title); 

  const setEditMode = useCallback(() => {
    if (!locked) {
      setMode(INPUT_MODE);
    }
    else {
      // TODO: Add indication of a locked click?
      console.log('Title [Locked]');
    }
  }, [locked]);
  
  const setLabelMode = useCallback(() => {
    setMode(LABEL_MODE);
  }, []);
  
  useEffect(()=> {
    setMode(deleteMode ? DELET_MODE : kInfo?.titleEdit ? INPUT_MODE : LABEL_MODE);
    setLocked(kInfo.titleLocked);
    setSuccess(kInfo.titleSuccess);
  }, [kInfo, deleteMode]);


  //--- Render ---

  const lockMe = useCallback((e) => {
    e.preventDefault();
    tagTitleLocked(folderPath, keyName)
      .then(()=> setLocked(true));
  },[tagTitleLocked, folderPath, keyName]);

  const unlockMe = useCallback((e) => {
    resetTitleLocked(folderPath, keyName)
      .then(()=>setLocked(false));
  },[resetTitleLocked, folderPath, keyName]);

  const hideDeleteDialog = useCallback(() => {
    setShowConfirm(false);
    setMode(LABEL_MODE);
  },[setShowConfirm]);

  // ---[  Render  ]---
  return (
    <div className={`keyTitleCtrl withGliders`} onContextMenuCapture={lockMe} {...rest}>
      <Leds isError={kInfo.titleErrorInfo?.errorTag.startsWith('prop-title')} />
      <Glide showLock={locked} unlocker={unlockMe}/>
      {mode === LABEL_MODE && <KeyTitleLabel title={title} setEditMode={setEditMode} isLocked={locked} isSuccess={success} isCustom={isCustom} key={`keyTitleOf-${keyName}`}/>}
      {mode === INPUT_MODE && <KeyTitleEdit folderPath={folderPath} keyName={keyName} title={title} setLabelMode={setLabelMode} kInfo={kInfo} tabIx={tabIx} />}
      {mode === DELET_MODE && <KeyTitleDelete folderPath={folderPath} keyName={keyName} hideMe={hideDeleteDialog}/>}
    </div>
  )
}
